import { IonIcon } from "@ionic/react";
import { chevronDown } from "ionicons/icons";
import React, { useState, useRef, useEffect } from "react";

export interface DropdownOption {
  label: string;
  value: string;
  colorClass?: string; // Tailwind class for text color (e.g., text-red-500)
}

interface CustomDropdownProps {
  options: DropdownOption[];
  selected: string;
  onChange: (value: string) => void;
  placeholder?: string;
  minWidth?: string | number;
  className?: string;
  textSizeClass?: string;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({
  options,
  selected,
  onChange,
  placeholder = "Select...",
  minWidth = 140,
  className = "",
  textSizeClass = "text-sm md:text-base lg:text-lg",
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const selectedOption = options.find((o) => o.value === selected);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      className={`relative inline-block text-left ${className}`}
      style={{ minWidth }}
    >
      {/* Trigger */}
      <div
      className={`flex items-center lg:h-10 justify-between border border-gray-300 rounded-md px-2 py-1 cursor-pointer bg-white ${textSizeClass} px-2 md:px-3 lg:px-4 py-1 md:py-2 lg:py-2.5`}
      onClick={() => setOpen(!open)}
      >
      <span
        className={`font-semibold ${
        selectedOption?.colorClass ?? "text-gray-800"
        }`}
      >
        {selectedOption ? selectedOption.label : placeholder}
      </span>
      <IonIcon icon={chevronDown} className="text-gray-500 ml-2" />
      </div>

      {/* Dropdown Menu */}
      {open && (
      <div className="absolute right-0 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg z-10">
        {options.map((option) => (
        <div
          key={option.value}
          onClick={() => {
          onChange(option.value);
          setOpen(false);
          }}
          className={`px-3 md:px-4 lg:px-5 py-1.5 md:py-2 lg:py-2.5 ${textSizeClass} cursor-pointer hover:bg-gray-100 ${
          option.value === selected ? "bg-gray-50" : ""
          } ${option.colorClass ?? "text-gray-800"}`}
        >
          {option.label}
        </div>
        ))}
      </div>
      )}
    </div>
  );
};

export default CustomDropdown;
